import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Basic explanation of what AI is" transition="fade" networkBackground="full">
      <div
        className="relative z-10 flex flex-col justify-center 
      h-full px-24 py-8 text-left font-light slide-scale-90"
      >
        <h2 className="title">Wat is Artificial Intelligence</h2>

        <div className="space-y-6">
          <p>
            Doorgaans wordt de term gebruikt voor systemen die menselijke intelligentie nabootsen
          </p>

          <p>Zelf gebruik ik de term liever in de breedste zin van het woord:</p>

          <div className="space-y-4">
            <p>Kunstmatig – alles dat gemaakt is</p>
            <p>Intelligentie – alles wat slim is</p>
          </div>
        </div>
      </div>
    </Slide>
  );
};
